<template>
    <div class="main dl_gray_color_bg">
        <mt-header :title="$t('任务中心')" class="dl_header_white dl_line_bottom" fixed>
          <mt-button icon="back" slot="left" @click="goback"></mt-button>
          <mt-button slot="right" @click="query()" style="color: #3c59db; font-weight: bold;">{{$t('任务记录')}}</mt-button>
        </mt-header>
        <div class="content" style="display: block;">
            <ul class="content_detail">
                <li v-for="val in hot">
                    <img v-bind:src="val.task_icon" class="oImg">
                    <span class="currency_name">{{val.task_name}} +{{val.rewards}} {{$t('积分')}}</span><br />
                    <span class="currency_desc">{{val.task_description}}</span>
                    <div class="amount_of wx_rt">
                        <p   @click="plandetail(val.task_identifier,val.task_status,val.task_id)" :class="classname[val.task_status]">{{name[val.task_status]}}</p>
                    </div>
                    <div class="clear"></div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import { Toast ,Swipe, SwipeItem} from 'mint-ui';
    import { httpGetBanner,httpGetHot } from "@/api/wealth";
    import { httpTaskList,httpFinishTask } from "@/api/index";
    export default{
        data:function() {  
            return {  
                name:['去完成','已完成','领取'],
                classname:['count wx_fontSize3','count wx_fontSize3 finish','count wx_fontSize3 go'],
                hot:[],
            }  
        }, 
        mounted(){
            this.getTask();
        },
        methods:{   
            goback: function() {
              window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
            },
            getTask: function() {
                httpTaskList()
                .then(res => {
                    this.hot = res.data.list;
                })
                .catch(() => {});
            },
            finish: function(task_id) {
                httpFinishTask({task_id: task_id})
                .then(res => {
                    this.getTask();
                    Toast(res.msg);
                })
                .catch(() => {});
            },
            huoqi(){
                this.$router.push('/pos')
            },
            siqi(){
                this.$router.push('/coinplan')
            },
            plandetail(type,status,task_id){
                console.log(status);
                console.log(task_id);
                if (status == 0) {
                    if (type == 'invite_user_deposit'){
                        this.$router.push({path:"/share"});
                    }else if(type == 'invite_user_reg'){
                        this.$router.push({path:"/share"});
                    }else if(type == 'send_redenvelope'){
                        this.$router.push({path:"/sendEnvelope"});
                    }else if(type == 'newbie_deposit'){
                        this.$router.push({path:"/index/wealth"});
                    }
                }else if(status == 2){
                    this.finish(task_id);
                }

            },
            mywealth(){
                this.$router.push('/mywealth')
            },
            against(){
                this.$router.push('/against')
            },
            query(){
                this.$router.push('/taskorder')
            },
        }
    }
</script>
<style scoped>
.main {
  padding-top: 40px;
  height: 100%;
  box-sizing: border-box;
}
hr{
    margin: 10px 5%;
    height: 1px;
    border: 0px;
    border-top: 1px solid #eee;
    padding: 0px;
    overflow: hidden;
    font-size: 0px;
    width: 90%;
}

.tl{
  text-align: left;
}
.fb{
  font-weight: bold;
}
.h40{
  height: 40px;
}
.l50{
  line-height: 50px;
}
.f20{
  font-size: 20px;
  font-weight: bold;
  line-height: 50px;
}
.f18{
  font-size: 18px;
}
.f16{
  font-size: 16px;
}
.f14{
  font-size: 14px;
}
.f12{
  font-size: 12px;
}

.wealth{width:100%;background:#f6f6f6;}
/*内容*/
.content{background:#f6f6f6;width:100%;}
.local{padding-top:0;}
.content_detail{padding:0 15px 0 15px;}
.content_detail li{width:100%;background:#fff;margin-top:12px;height: 70px;position: relative;}
.oImg{
    width: 34px;
    height: 34px;
    margin: 15px 10px 5px 14px;
}
.currency_name{
    position: relative;
    top: -20px;
    font-size: 14px;
    font-weight: bold;
}
.currency_desc{
    position: absolute;
    top: 40px;
    font-size: 12px;
    left: 58px;
}
.amount_of{width:25%;text-align: center;}
.count{
    color: #3c59db;
    padding: 7px 12px;
    font-weight: normal;
    position: absolute;
    right: 15px;
    top: 20px;
    font-size: 14px;
    background-color: #EBEEFF;
    border-radius: 5px;
    border: 1px solid #3d59d2;
    min-width: 68px;
}
.count.finish{
    border-color: #f4f4f6;
    background-color: #f4f4f6;
    color: #999;  
}
.go{
    border-color: #627eea;
    background-color: #627eea;
    color: #fff;  
}

.money{color:#8c92a8;}
/*分享*/
.share{width:150px;position: absolute;background:#fff;top:68px;right: 15px;border-radius: 6px;box-shadow:0 0 20px rgba(5,61,109,0.2);}
.share li{margin:0 15px;height:51px;border-bottom: 1px solid #e3e8ed;line-height: 51px;}
.mark{width:20px;height:20px;margin:0 16px 0 5px;}
.main{color:#212529;position: relative;top:-4px;}
.triangle{position: relative;top:-8px;left:80%;}
.triangle_border_up{
    width:0;
    height:0;
    border-width:0 8px 8px;
    border-style:solid;
    border-color:transparent transparent #fff;/*透明 透明  灰*/
    position:relative;
}
.mywealth{
    font-size: 14px;
    margin-right: 15px;
    color: #fff;
}
.shandui{
    width: 55px;
    height: 25px;
    margin-left: 15px;
}

.page-swipe img {
    width: 100%;
    height: 200px;
}
.page-swipe .mint-swipe-item {

}
.page-swipe .slide1 {
  background-color: #0089dc;
  color: #fff;
}
.page-swipe .slide2 {
  background-color: #ffd705;
  color: #000;
}
.page-swipe .slide3 {
  background-color: #ff2d4b;
  color: #fff;
}
.page-swipe-desc {
  text-align: center;
  color: #666;
}

.footer{width:100%;height:75px;position: relative;}
.footer .item{
    width: 50%;
    height: 100%;
    font-size: 16px;
    color: #212529;
    text-align: center;
    background: #fff;
    position: absolute;
    top: 0;
}
.footer .item .detail{
    height: 38px;
    position: absolute;
    top: 19px;
    width: 100px;
    left: 50%;
    margin: 0 0 0 -50px;
}
.footer .item span{
    line-height: 38px;
    display: inline-block;
    position: absolute;
    width: 80px;
    left: 50px;
    text-align: left;
}
.footer .item.right{
    right: 0;
}
.footer .item img{
    width: 38px;
    display: block;
    position: absolute;
}
.remen{
    font-size: 16px;
    padding: 18px 15px 8px 15px;
    color: #212529;
    font-weight: bold;
}
.left_lable{
    font-size: 12px;
    padding: 5px 8px;
    background-color: #f6f6f6;
    margin: 0 0 10px 10px;
    float: left;
    border-radius: 4px;
    color: #8c92a8;
}
.right_lable{
    font-size: 12px;
    padding: 5px 8px;
    margin:0 10px;
    float: right;
    border-radius: 4px;
    color: #8c92a8;
}
.clear{
    clear: both;
}
.line{
    width: 0;
    height: 40px;
    border-right: 1px solid #e3e8ed;
    position: absolute;
    left: 50%;
    z-index: 1;
    top: 16px;
}
.bgfff{
    background-color: #fff;
}
</style>